import { useState, useCallback } from 'react';
import fireworkAnimation from '../assets/lotties/firework_1.json';

export interface LottieAnimationConfig {
  animationData?: any;
  loop?: boolean;
  autoplay?: boolean;
  speed?: number;
  fullscreen?: boolean;
  showCloseButton?: boolean;
  duration?: number; // 自动关闭时间（毫秒）
  onComplete?: () => void;
  onClose?: () => void;
}

export const useLottieAnimation = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentConfig, setCurrentConfig] = useState<LottieAnimationConfig | null>(null);

  const playAnimation = useCallback((config: LottieAnimationConfig = {}) => {
    const finalConfig: LottieAnimationConfig = {
      animationData: fireworkAnimation,
      loop: false,
      autoplay: true,
      speed: 1,
      fullscreen: true,
      showCloseButton: false,
      duration: 3000,
      ...config,
    };

    setCurrentConfig(finalConfig);
    setIsPlaying(true);

    // 如果设置了自动关闭时间
    if (finalConfig.duration && finalConfig.duration > 0) {
      setTimeout(() => {
        stopAnimation();
      }, finalConfig.duration);
    }
  }, []);

  const stopAnimation = useCallback(() => {
    setIsPlaying(false);
    setTimeout(() => {
      setCurrentConfig(null);
    }, 300); // 等待退出动画完成
  }, []);

  const playFirework = useCallback((config: Omit<LottieAnimationConfig, 'animationData'> = {}) => {
    playAnimation({
      animationData: fireworkAnimation,
      loop: false,
      autoplay: true,
      speed: 1,
      fullscreen: true,
      showCloseButton: false,
      duration: 3000,
      ...config,
    });
  }, [playAnimation]);

  const handleAnimationComplete = useCallback(() => {
    if (currentConfig?.onComplete) {
      currentConfig.onComplete();
    }
    if (!currentConfig?.loop) {
      // 如果不循环，动画完成后自动关闭
      setTimeout(() => {
        stopAnimation();
      }, 500);
    }
  }, [currentConfig, stopAnimation]);

  const handleAnimationClose = useCallback(() => {
    if (currentConfig?.onClose) {
      currentConfig.onClose();
    }
    stopAnimation();
  }, [currentConfig, stopAnimation]);

  return {
    isPlaying,
    currentConfig,
    playAnimation,
    stopAnimation,
    playFirework,
    handleAnimationComplete,
    handleAnimationClose,
  };
};

export default useLottieAnimation;